import React from 'react';
import { CATEGORY_MODAL_CATEGORY, CATEGORY_MODAL_PRODUCT, CATEGORY_MODAL_SECTIONS, ICategoryOrProductItem } from '../../CategoryAndProductModal';
import { DEBOUNCE_TIME } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { MODALS_CRUMB } from 'src/types/main';
import { getTranslate } from 'src/utils/helpers';
import ModalActionButton from 'src/view/components/Controls/Modal/ModalActionButton/ModalActionButton';
import SearchInput from 'src/view/components/Controls/SearchInput/SearchInput';
import Crumbs, { CrumbsType, ICrumb } from '~/view/components/Controls/Crumbs';

interface IProps {
  search: string;
  section: CATEGORY_MODAL_SECTIONS;
  activeCrumb: MODALS_CRUMB;
  isMulty?: boolean;
  isAll?: boolean;

  selectedItems: ICategoryOrProductItem[];
  selectedUnavailableItemsLength: number;
  isProducts?: CATEGORY_MODAL_PRODUCT;
  isCategories?: CATEGORY_MODAL_CATEGORY;
  loading?: boolean;
  clickSection: (value: CATEGORY_MODAL_SECTIONS) => void;
  clickCrumb: (crumb: MODALS_CRUMB) => void;
  clickSelectAll: () => void;
  clickDeselectAll: () => void;
  onSearch: (value: string) => void;
}

export default class CategoryAndProductModalHeader extends React.Component<IProps, {}> {
  onSearch = (text: string) => {
    this.props.onSearch(text);
  };

  renderSearchInput = () => {
    return (
      <SearchInput
        className="custom-modal-header__search"
        inputClassName="custom-modal-header__search-input"
        onChangeText={this.onSearch}
        value={this.props.search}
        placeholder="txt_search"
        loading={this.props.loading}
        withResetIcon
        customPlaceholder
        debounceDelay={DEBOUNCE_TIME.MEDIUM}
      />
    );
  };

  renderControls = () => {
    if (this.props.isMulty) {
      return (
        <div className="d-flex flex-row gap-20">
          {this.props.search ? null : <ModalActionButton title={localeStore.t('select_all')} onClick={this.props.clickSelectAll} />}
          <ModalActionButton title={localeStore.t('deselect_all')} onClick={this.props.clickDeselectAll} />
        </div>
      );
    } else if (this.props.selectedItems && this.props.selectedItems.length) {
      return (
        <div className="d-flex flex-row align-items-center">
          <p className="family-medium text-size-14">{localeStore.t('selected')}</p>
          <p className="custom-modal-header-selected-item-title family-semibold text-size-14 mx-3">
            {getTranslate(this.props.selectedItems[0]?.name)}
          </p>
          <ModalActionButton title={localeStore.t('deselect')} onClick={this.props.clickDeselectAll} type="some" />
        </div>
      );
    } else return null;
  };

  get headerCrumbs(): ICrumb[] {
    return [
      { value: CATEGORY_MODAL_SECTIONS.CATEGORIES, label: 'categories' },
      { value: CATEGORY_MODAL_SECTIONS.ITEMS, label: 'items' },
    ];
  }

  render() {
    const selectedItemsLength: number = this.props.selectedItems.length - this.props.selectedUnavailableItemsLength;
    return (
      <div className="d-flex flex-column justify-content-between px-8 pt-6 pb-3">
        {/* section block */}
        {!this.props.isMulty ? null : (
          <div className="d-flex flex-row align-items-center justify-content-between mb-4">
            {this.props.isCategories === CATEGORY_MODAL_CATEGORY.NONE || this.props.isProducts === CATEGORY_MODAL_PRODUCT.NONE ? null : (
              <Crumbs
                type={CrumbsType.TAB}
                crumbs={this.headerCrumbs}
                activeCrumb={this.props.section}
                onClick={this.props.clickSection}
                translateLabel
                withPartition
              />
            )}
            {this.props.isMulty ? this.renderSearchInput() : null}
          </div>
        )}

        {/* section block end */}
        {/* crumbs and controls string */}
        <div className="d-flex flex-row justify-content-between">
          {this.props.isMulty ? (
            <Crumbs
              crumbs={[
                { label: localeStore.t('all'), value: MODALS_CRUMB.ALL },
                {
                  label:
                    this.props.isMulty && (selectedItemsLength || this.props.isAll)
                      ? localeStore.t('selected') + ` (${this.props.isAll ? localeStore.t('all') : selectedItemsLength})`
                      : localeStore.t('selected'),
                  value: MODALS_CRUMB.SELECTED,
                },
              ]}
              activeCrumb={this.props.activeCrumb}
              onClick={this.props.clickCrumb}
            />
          ) : (
            this.renderSearchInput()
          )}
          {this.renderControls()}
        </div>
        {/* crumbs and controls string end */}
      </div>
    );
  }
}
